import remote from "../../services/remote";
import {
    getCaseHistorySuccess,
    getCaseHistoryFailure
} from "./actions";
import { GET_CASE_HISTORY_REQUEST } from "./constants";
import { call, put, takeLatest } from "redux-saga/effects";
import SentryManager from "../../monitoring/Sentry";

function* getCaseHistory (action) {
    const url = `/history/${action.data.caseId}?${new URLSearchParams(action.data.pagination).toString()}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get',
        });
        if (response.success) {
            yield put(getCaseHistorySuccess(response.data));
        } else {
            yield put(getCaseHistoryFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchHistory() {
    yield takeLatest(GET_CASE_HISTORY_REQUEST , getCaseHistory);
}



// WEBPACK FOOTER //
// ./src/containers/History/saga.js